export default {
  "pl": {
    "analytics": {
      "labels": {
        "click_seen_by": "Kliknij, aby zobaczyć, którzy klienci widzieli tę zawartość",
        "click_shared_with": "Kliknij, aby zobaczyć, którzy klienci widzieli tę zawartość",
        "deleted": "Usunięto",
        "deleted_item": "Ten element został usunięty i nie możesz go kliknąć",
        "noCustomers": "Nie przypisano jeszcze klientów do tego poziomu.",
        "noCustomersSeen": "Żaden z klientów nie widział jeszcze tej zawartości.",
        "noCustomersUnseen": "Wszyscy klienci widzieli tę zawartość.",
        "noUnitAccess": "Brak dostępu do jednostki",
        "notSeen": "Nie wyświetlono ({number})",
        "seen": "Wyświetlono ({number})",
        "seenBy": "Zawartość wyświetlona przez:",
        "sharedWithMultipleUnits": "Nie udostępniono klientom na poziomie: {level_name} | Udostępniono 1 klientowi na poziomie: {level_name} | Udostępniono {customers_count} klientom na poziomie: {level_name}",
        "sharedWithUnit": "Udostępniono jednostce: {unit_name}",
        "units": "Brak jednostek | 1 jednostka | Liczba jednostek: {count}",
        "views": "Wyświetlenia",
        "viewsCount": "Brak wyświetleń | 1 wyświetlenie | Liczba wyświetleń: {count}"
      }
    }
  }
}
